import { useMemo } from 'react'
import { OrderType } from 'types/checkout'
import { CheckoutItemType } from 'types/checkoutItem'

const useFlatCheckoutItems = (orders: OrderType[]): CheckoutItemType[] => {
  return useMemo(() => {
    return orders.reduce((prev: CheckoutItemType[], order) => [...prev, ...order.items], [])
  }, [orders])
}

export default useFlatCheckoutItems
